import React from "react";
import classes from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { Iconfont } from "../../../../components/icon/iconfont";
import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { useMemo } from "react";

// 下拉框选择国家 有输入搜索功能
export default props =>{
    useStyles(classes);
    const { defaultV, type, optionClick, countries } = props
    const [selectOpen, setSelectOpen] = useState(false)
    const [searchValue, setSearchValue] = useState('')
    const selectRef = useRef()

    const openSelect = (e) => {
        setSelectOpen(!selectOpen)
        setSearchValue('')
    }

    useEffect(() => {
         // 点击其他区域关闭弹窗
         if(type == 'select'){
            document.addEventListener("click",(e) => closeItem(e),false)
         }

         return () => {
            if(type == 'select'){
                // 页面销毁前移除监听
                document.removeEventListener("click",(e) => closeItem(e),false);   
            }
         }
    }, [])

    const closeItem = (e) => {
        if(!selectRef.current?.contains(e?.target)){
            setSelectOpen(false)
        }
    }

    const searchChange = e => {
        setSearchValue(e?.target?.value || '')
    }

    const sameCountry = useMemo(() => {
        if(countries?.length > 0){
            let includeCountry = countries;
            if(searchValue){
                let reg = new RegExp(searchValue+'', 'ig')
                includeCountry = countries?.filter(c => {
                    return reg.test(c?.label)
                })
                includeCountry?.forEach((item)=>{
                    // console.log(item)
                    item.labelS = item?.label?.replace(reg, (e)=>{
                        return '<span style="color:#999;padding:0;">'+e+'</span>'
                    })
                })
                return includeCountry
            } else {
                includeCountry?.forEach(item => {
                    item.labelS = item.label
                })
                return includeCountry
            }
        }
    }, [countries, searchValue])

    return (
        <div className={classes.SelectBox} ref={selectRef}>
            <div className={classes.SelectInputBox} onClick={() => openSelect()} >
                <span>{defaultV}</span>
                {
                    selectOpen ?
                    <div className={classes.SelectOptionBorderBox}>
                        <div className={classes.SearchBar}>
                            <Iconfont className={classes.SearchBarIcon}>&#xe772;</Iconfont>
                            <input type="text"
                                onInput={(e) => searchChange(e)}
                                placeholder="Country/Region"
                                />
                        </div>
                        <div className={classes.SelectOptionBox}>
                            {
                                sameCountry?.map((item, index) => (
                                    <div className={`${classes.SelectOption} ${defaultV == item?.value ? classes.SelectOptionSelect: ''}`}
                                        key={index}
                                        value={item?.value}
                                        onClick={(e) => {
                                            e?.stopPropagation()
                                            setSelectOpen(false)
                                            optionClick(item)
                                        }}
                                        >
                                        <span dangerouslySetInnerHTML={{__html: item?.labelS}}></span>
                                    </div>
                                ))
                            }
                        </div>
                    </div>:
                    <React.Fragment></React.Fragment>
                }
            </div>
            <Iconfont className={`${classes.SelectIcon} ${selectOpen? classes.OptionOpen: ''}`}>&#xe692;</Iconfont>
        </div>
    )
}